'use client';

import clsx from 'clsx';
import { useLocale } from 'next-intl';
import { useEffect, useState } from 'react';

import { useCurrency } from '@/providers/CurrencyProvider';

import { localizePriceCurrency } from '@/utils/storyblok';
import styles from './LocalizedPrice.module.scss';

type LocalizePriceProps = {
    price: number;
    defaultCurrency?: string;
    className?: string;
};

export const LocalizedPrice = ({ price, defaultCurrency, className }: LocalizePriceProps) => {
    const { currency, getExchangeRate } = useCurrency();
    const locale = useLocale();

    const [exchangeRate, setExchangeRate] = useState<number>(1);

    useEffect(() => {
        async function fetchRate() {
            try {
                const rate = await getExchangeRate(defaultCurrency, currency);
                setExchangeRate(rate);
            } catch (error) {
                console.error('Error fetching exchange rate', error);
            }
        }
        if (currency && defaultCurrency) {
            fetchRate();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currency]);

    return (
        <span className={clsx(styles.root, className)}>
            {
                localizePriceCurrency(price, defaultCurrency ?? currency, currency, locale, {
                    exchangeRate,
                }).converted
            }
        </span>
    );
};
